<template>
  <v-toolbar flat class="mb-4">
    <v-toolbar-title>
      {{ title }}
      <span></span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-2"
            color="accent"
            fab
            small
            router
            to="/script"
            v-on="on"
          >
            <v-icon dark>mdi-language-javascript</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("script.name") }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }" v-if="permitted('Script.Create')">
          <v-btn
            class="mx-2"
            fab
            small
            color="primary"
            router
            to="/script/create"
            v-on="on"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("common.create") }}</span>
      </v-tooltip>
    </div>
  </v-toolbar>
</template>

<script>
export default {
  name: "ScriptToolbar",
  props: {
    title: String,
  },
};
</script>